import {get, post} from 'external/axios';

export class PaymentService {

    async completePurchase(purchaseCart) {
        return post('/payment/complete-purchase', purchaseCart);
    }

    async createSessionCheckout(response) {
        return post('/payment/create-checkout-session', response);
    }

    async getSessionRetriveById(id) {
        return get(`/payment/success/${id}`);
    }
    
    async cancelSubscription(request) {
		return post('/payment/cancel-subscription', request);
	}

	async reactiveSubscription(request) {
		return post('/payment/reactive-subscription', request);
	}

    async activateCanceledSubscription(request) {
        return post('/payment/activate-canceled-subscription', request)
    }

	async updatePaymentMethod(request) {
		return post('/payment/update-payment-method', request);
	}

    async getPaymentHistory(subscription_id) {
        return get(`/payment/history/${subscription_id}`);
    }

}

export const paymentService = new PaymentService();